import axios from "axios";
import Fingerprint2 from 'fingerprintjs2'
import { message as Message } from "antd";

const request = axios.create({
    baseURL: process.env.NODE_ENV == 'development' ? 'https://dev-api.stadeo.live/' : 'https://api.stadeo.live/',
    timeout: 80000,
    headers: {
        "Content-Type": "application/json;charset=utf-8",
        "Device-Type": 'web',
        "Access-Control-Allow-Origin":"*"
    },
});
Fingerprint2.get((components) => {
    const values = components.map((component, index) => {
        if (index === 0) {
            return component.value.replace(/\bNetType\/\w+\b/, '')
        }
        return component.value
    })
    const nurmur = Fingerprint2.x64hash128(values.join(''), 31)
    localStorage.setItem("DeviceId", window.btoa(nurmur + window.location.host));
})
request.interceptors.request.use(
    async (config) => {
        config.headers["Device-Id"] = localStorage.getItem("DeviceId");
        if (localStorage.getItem('login')) {
            const login = JSON.parse(localStorage.getItem('login'))
            config.headers.Token = login.token;
            config.headers.UserId = login.guid;
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);
request.interceptors.response.use(
    (response) => response.data,
    (error) => {
        const { code, message } = error.response.data;
        if (code == 440) {
            Message.error({
                content: message,
                maxCount: 1,
                onClose: () => {
                    localStorage.removeItem("login");
                    window.location.reload();
                }
            })

        }
        if (!axios.isCancel(error)) {
            return Promise.reject(error.response.data);
        }

    }
);
export default request;
